import gql from 'graphql-tag';

export default
gql `mutation createActivity($input: CreateActivityInput!){
		createActivity(input: $input){
            id
            username
            actDate
            activityType
            value
            intensity
            notes
		}
	}
`;


// WEBPACK FOOTER //
// ./src/components/mutations/CreateActivityMutation.js